// selectの年の選択肢を生成
export const initYearSelects = () => {
  const selects = document.querySelectorAll('.js-year-select');

  if (!selects.length) return;

  selects.forEach(select => {
    const currentYear = new Date().getFullYear();

    const startYear = Number(select.dataset.startYear) || currentYear - 80;
    const endYear = Number(select.dataset.endYear) || currentYear;
    const selectedYear = select.dataset.selected;

    const options = [
      `<option value="" hidden ${selectedYear ? '' : 'selected'}></option>`
    ];

    for (let year = endYear; year >= startYear; year--) {
      const selected = String(year) === selectedYear ? ' selected' : '';
      options.push(`<option value="${year}"${selected}>${year}</option>`);
    }

    select.innerHTML = options.join('');

    if (!selectedYear) {
      select.value = '';
    }
  });
};

// 選択された年・月に応じて存在しない日付を非表示にする
export const initBirthdaySelect = () => {
  const yearSelect = document.getElementById('birth-year');
  const monthSelect = document.getElementById('birth-month');
  const daySelect = document.getElementById('birth-day');

  if (!yearSelect || !monthSelect || !daySelect) return;

  const updateDays = () => {
    const year = parseInt(yearSelect.value, 10);
    const month = parseInt(monthSelect.value, 10);

    Array.from(daySelect.options).forEach(option => {
      option.hidden = false;
    });

    if (!year || !month) return;

    const maxDays = new Date(year, month, 0).getDate();

    Array.from(daySelect.options).forEach(option => {
      const value = parseInt(option.value, 10);

      if (value > maxDays) {
        option.hidden = true;
      }
    });

    if (parseInt(daySelect.value, 10) > maxDays) {
      daySelect.value = '';
    }
  };

  yearSelect.addEventListener('change', updateDays);
  monthSelect.addEventListener('change', updateDays);

  updateDays();
};